import ActionTypes from './container/actionType';

const DetailReducers = (state = {
    selectedQuiz: [],
    QuizQuestions: [],
    FavoriteQuizData: [],
    qLength: '',
    FavorSuccess: '',
    FavorFlag: false,
    FavorError: '',
    FavorErrorFlag: false,
}, action) => {
    switch (action.type) {
        case ActionTypes.CurrentQuiz: {
            return state = {
                ...state,
                selectedQuiz: action.payload
            }
        }
        case ActionTypes.QuizDetails: {
            return state = {
                ...state,
                QuizQuestions: action.payload
            }
        }
        case ActionTypes.length: {
            return state = {
                ...state,
                qLength: action.payload
            }
        }
        case ActionTypes.Favorite:{
            return state = {
                ...state,
                FavorSuccess: action.payload
            }
        }
        case ActionTypes.FavoriteFlag:{
            return state = {
                ...state,
                FavorFlag: !state.FavorFlag
            }
        }
        case ActionTypes.FavoriteError:{
            return state = {
                ...state,
                FavorError: action.payload
            }
        }
        case ActionTypes.FavoriteErrorFlag:{
            return state = {
                ...state,
                FavorErrorFlag: !state.FavorErrorFlag
            }
        }
        case ActionTypes.FavoriteData:{
            return state = {
                ...state,
                FavoriteQuizData: action.payload
            }
        }
        default: { }
    }
    return state;
}
export default DetailReducers;


// WEBPACK FOOTER //
// ./src/reducers/detailsReducers.jsx